<template>
    <v-container fluid>
        <v-row dense>
            <v-col class="pa-0" md="6" sm="12"> <SeafarerContractDaysStatistics /> </v-col>
            <v-col class="pa-0" md="6" sm="12"> <SickLeaveStatistics /> </v-col>
            <v-col class="pa-0" md="6" sm="12"> <MonthlyBreakdownStatistics /> </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SeafarerContractDaysStatistics from './SeafarerContractDaysStatistics.vue';
import SickLeaveStatistics from './SickLeaveStatistics.vue';
import MonthlyBreakdownStatistics from './MonthlyBreakdownStatistics.vue';
export default {
    name: 'Statistics',
    components: {
        SeafarerContractDaysStatistics,
        SickLeaveStatistics,
        MonthlyBreakdownStatistics,
    },
    data() {
        return {};
    },
    watch: {},
    computed: {},
    methods: {},
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        if (this.$myStore.state.user.user_role_id != 1) {
            this.$router.replace('/dashboard');
        }
        this.$myStore.commit('setBreadcrumbs', []);
    },
};
</script>

<style scoped></style>
